module.exports = __webpack_public_path__ + "static/media/token1.28f169b2.svg";